import React, { useState, useEffect } from "react";
import {
    Drawer,
    Button,
    Typography,
    IconButton,
    List,
    ListItem,
    ListItemPrefix,
    ListItemSuffix,
    Chip,
    Select,
    Option,
} from "@material-tailwind/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
    PresentationChartBarIcon,
    ShoppingBagIcon,
    UserCircleIcon,
    Cog6ToothIcon,
    InboxIcon,
    PowerIcon,
} from "@heroicons/react/24/solid";
import logo_h from './../../assets/images/logo_h.jpeg'
import { useShared } from "../../hooks/useShared";
import { sidebarMenu } from "./sideMenuList";
import AAvatar from "../partials/AAvatar";
import AIcon from "../partials/AIcon";
import { NavLink, useLocation } from "react-router-dom";
import LanguagesMenu from "../header/menus/LanguagesMenu";


export function ADrawer() {

    const location = useLocation()
    const [selectedItem, setSelectedItem] = useState(false)
    const [showChildren, setShowChildren] = useState(false)
    const [authMenu, setAuthMenu] = useState([])



    const { auth, itemCounts, openDrawer, setOpenDrawer, getLanguage, setLanguage } = useShared();

    useEffect(() => {
        // openSubMenu(null)
        setAuthMenu([])
        sidebarMenu?.map(sm => {
            if (auth.hasRole(sm?.roles)) {
                setAuthMenu(pre => [...pre, sm])
            }
        })

    }, [])



    const setSideBarMenuItems = (sm) => {
        return (
            <>
                <AIcon size={18} name={sm?.icon} className={`  ${sm?.colors[0]} ${getLanguage() === 'dr' ? '!ml-2' : 'mr-2'}`} />

                <span className={getLanguage() === 'dr' ? 'amiriR text-base' : 'text-xs'}>{getLanguage() === 'dr' ? sm.name_af : sm?.name} </span>
                {sm?.count > 0 && <AAvatar num={sm?.count} className={sm?.colors[1]} />}
                {sm?.children.length > 0 && <AIcon size={20} name="chevron-down-outline" className={`  ${getLanguage() === 'dr' ? '!mr-auto' : 'ml-auto'} ${sm?.name === selectedItem?.name && showChildren ? "rotate-180" : ""} `} />}

            </>
        )
    }

    const MyNavBar = ({ sm }) => {
        return (
            <NavLink className={({ isActive }) => ` duration-1000  menuClass ${isActive ?
                ` bg-red-900  !text-white font-semibold hover:!bg-main-color ${sm?.children?.length > 0 && selectedItem?.link === sm?.link && '!rounded-b-none'}` : 'text-gray-700'}`} to={sm?.link}>
                {setSideBarMenuItems(sm)}
            </NavLink>
        )
    }


    useEffect(() => {
        if (itemCounts?.length > 0) {
            authMenu.filter((x, i) => itemCounts.some(y => {
                if (x.link === y.name) {
                    authMenu[i].count = y.count
                    return true
                }
            }));
        }
    }, [])


    const openSubMenu = (sm) => {
        if (sm?.children?.length > 0) {
            setShowChildren(pre => !pre) //when open and close
            setSelectedItem(sm)

        }

        else if (sm === null) {
            const isIt = authMenu.find((s, i) => s?.children?.find(c => {
                if (c?.link === location.pathname) return authMenu[i]
            }))
            if (isIt) {
                setShowChildren(true)
                setSelectedItem(isIt)

            }
            else {
                const test = authMenu.find((s, i) => {
                    if (s?.link === location.pathname) {
                        return authMenu[i]
                    }
                })
                setSelectedItem(test)
            }

        } else {
           
            setShowChildren(false)
            setSelectedItem(sm)

        }
      
    }

    const handleMenuClick = (sm) => {
        if (sm?.children?.length > 0) openSubMenu(sm)
        else setOpenDrawer(false)
    }

    const chnageLang = (e) => {
       
        setLanguage(e)
    }
    const getDirection = () => getLanguage() === 'dr' ? "rtl" : 'ltr'

    return (
        <React.Fragment>
            <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)} className={`bg-main-color text-white`} placement="right" >
                <div className="mb-2 flex items-center justify-between ">
                    {/*     <Typography variant="h5" color="white">
            ACMEG
          </Typography> */}
                    <img src={logo_h} alt="" />
                    <IconButton variant="text" color="blue-gray" onClick={() => setOpenDrawer(false)} className="!absolute left-0 top-0 bg-main-color  h-6 w-6">
                        <XMarkIcon strokeWidth={2} className="h-5 w-5 text-white" />
                    </IconButton>
                </div>
                <div className="sidebar-content px-4 py-6 overflow-y-auto h-[88vh] api-scroll">
                    <ul className="flex flex-col w-full">

                        {
                            authMenu.map((sm, index) => (
                                <li className="my-px" key={index}  >
                                    <div onClick={() => handleMenuClick(sm)} style={{ direction: getDirection() }}>
                                        {
                                            <>{sm?.children?.length > 0 ?
                                                <div className={` duration-1000  menuClass text-gray-700 cursor-pointer ${selectedItem?.name === sm?.name && showChildren ?
                                                    'bg-red-900  !text-white font-semibold hover:!bg-main-color !rounded-b-none' : ''}`} >
                                                    {setSideBarMenuItems(sm)}
                                                </div> : sm.name === "Admin Roles" ?
                                                    <div className={`text-gray-300  mt-3  pl-1 rounded-sm ${getLanguage() === 'dr' ? 'amiriR text-base text-right' : 'text-sm'}`}>{getLanguage() === 'dr' ? sm.name_af : sm?.name}</div>
                                                    : <MyNavBar sm={sm} />

                                            }</>
                                        }
                                    </div>

                                    {/*  submenu */}
                                    {sm?.children.length > 0 &&
                                        <ul className={`${selectedItem?.name === sm?.name && showChildren ? "max-h-50 p-1 border border-main-color rounded-b-lg" : "max-h-0 border-none"} overflow-hidden  duration-500  flex flex-col relative bg-red-500 `}>
                                            {sm?.children.map((ch, i) => {
                                                return (
                                                    <li onClick={() => handleMenuClick(ch)} style={{ direction: getDirection() }} key={i}>
                                                        {auth.hasRole(ch?.roles) && <NavLink className={({ isActive }) => `menuClass  m-1 ${isActive ? '!text-gray-900 bg-gray-300/50' : ''}`} to={ch.link}>
                                                            <span className={getLanguage() === 'dr' ? 'amiriR text-base' : ''}>{getLanguage() === 'dr' ? ch.name_af : ch?.name}</span>
                                                        </NavLink>}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    }
                                </li>
                            ))
                        }
                        <li className="mt-2">
                            <Select label={getLanguage() === 'dr' ? "انتخاب زبان" : 'Change Language'} className={`text-white ${getLanguage() === 'dr' && 'text-xl'} `} onChange={chnageLang} value={getLanguage()}
                                labelProps={{
                                    className: 'text-white',
                                }}
                            >
                                <Option value="dr" className="amiriB  text-lg">دری</Option>
                                <Option value="en" >English</Option>
                            </Select>
                        </li>
                    </ul>
                </div>
                <div className='text-center p-2 h-[2vh] text-blue-gray-200 text-xs'>ACMEG DB v1.0.0</div>

            </Drawer>
        </React.Fragment>
    );
}